module.exports = __webpack_public_path__ + "img/(2).7309c275.jpg";